import { useState } from 'react';
import { KhuVuc } from '@/types/schemas/khu-vuc.type';
import { Group } from '@/types/schemas/group.type';

/**
 * Hook for managing search field states in the khu-vuc feature
 *
 * @param initialData - Initial khu-vuc data (optional)
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = (initialData?: KhuVuc) => {
  // Parent state
  const [parent, setParent] = useState<KhuVuc | null>(initialData?.parent_rg_data || null);

  // Group states
  const [nh_rg1_group, setGroup1] = useState<Group | null>(initialData?.nh_rg1_group || null);
  const [nh_rg2_group, setGroup2] = useState<Group | null>(initialData?.nh_rg2_group || null);
  const [nh_rg3_group, setGroup3] = useState<Group | null>(initialData?.nh_rg3_group || null);

  return {
    parent,
    setParent,
    nh_rg1_group,
    setGroup1,
    nh_rg2_group,
    setGroup2,
    nh_rg3_group,
    setGroup3
  };
};
